import React from "react";
import { mission } from "../mock";
import Reveal from "./Reveal";

const Mission = () => {
  return (
    <section id="about" className="bg-white py-8 md:py-14">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <div className="relative">
              <div
                className="absolute -inset-3 rounded-[28px] rotate-[-2deg]"
                style={{ backgroundColor: "rgba(24,126,228,0.12)" }}
              />
              <img
                src={mission.image}
                alt={mission.imageAlt}
                className="relative rounded-3xl shadow-xl w-full object-cover"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <ul className="space-y-4">
              {mission.bullets.map((b) => (
                <li key={b} className="flex gap-3 text-slate-600 text-base md:text-lg leading-relaxed font-medium">
                  <img src="/me-badge.png" alt="" aria-hidden="true" className="shrink-0 w-8 h-8 mt-0.5 object-contain" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Mission;
